import { useTranslation } from 'next-i18next'
import { Dispatch, SetStateAction } from 'react'
import ChevronRightIcon from 'assets/icons/nucleo/18px_chevron-right.svg'
import StyledRunnerIcon from 'assets/icons/nucleo/18px_ticket-2.svg'
import { NavigationItem } from 'components/Layout/Header/DisciplineContent/NavigationItem'
import { minWidthIcon } from 'components/Layout/Header/Header.style'

interface RaceTypeSelectorButtonProps {
  setIsSelectingRaceType: Dispatch<SetStateAction<boolean>>
}

export const RaceTypeSelectorButton = ({
  setIsSelectingRaceType
}: RaceTypeSelectorButtonProps) => {
  const { t } = useTranslation('common')
  return (
    <NavigationItem
      leftIcon={<StyledRunnerIcon />}
      text={t('menu.raceType')}
      rightIcon={<ChevronRightIcon css={minWidthIcon} />}
      onClick={() => setIsSelectingRaceType(true)}
    />
  )
}
